import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, PipeTransform } from '@angular/core';
import { DeliveryNoteSettingsDto } from '@dto/deliveryNoteSettingsDto';
import { DeliveryNotesTableEntry } from '@dto/deliveryNotesTableEntry';
import { TransactionDeliveryNoteDto } from '@dto/transactionDeliveryNoteDto';
import { DeliveryNote } from '@models/deliveryNote';
import { Observable } from 'rxjs';
import { DeliveryNoteName } from '../../dto/deliveryNoteName';
import { EntityService } from './entity.service';

@Injectable({
  providedIn: 'root'
})
export class DeliveryNotesService extends EntityService {

  public entityRoute = "deliverynotes";

  constructor(http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(http, baseUrl);
  }

  getDeliveryNote(deliveryNoteId: number): Observable<DeliveryNote> {
    return this.http.get<DeliveryNote>(this.baseUrl + 'api/deliverynotes/' + deliveryNoteId);
  }

  getDeliveryNotes(): Observable<DeliveryNotesTableEntry[]> {
    return this.http.get<DeliveryNotesTableEntry[]>(this.baseUrl + 'api/deliverynotes');
  }

  getDeliveryNotesOfCustomer(customerId: number): Observable<DeliveryNotesTableEntry[]> {
    return this.http.get<DeliveryNotesTableEntry[]>(this.baseUrl + 'api/deliverynotes/customer/' + customerId);
  }
  
  createDeliveryNoteSettings(customerId: number): Observable<DeliveryNoteSettingsDto> {
    return this.http.get<DeliveryNoteSettingsDto>(this.baseUrl + 'api/deliverynotes/settings/' + customerId + '/create');
  }
  
  getDeliveryNoteSettings(customerId: number): Observable<DeliveryNoteSettingsDto> {
    return this.http.get<DeliveryNoteSettingsDto>(this.baseUrl + 'api/deliverynotes/settings/' + customerId);
  }
  
  patchDeliveryNoteSettings(customerId: number, deliveryNoteSettings: DeliveryNoteSettingsDto): Observable<DeliveryNoteSettingsDto> {
    return this.http.patch<DeliveryNoteSettingsDto>(this.baseUrl + 'api/deliverynotes/settings/' + customerId + '/patch', deliveryNoteSettings);
  }

  async getTransactionsOfDeliveryNoteAsync(deliveryNoteId: number): Promise<TransactionDeliveryNoteDto[]> {
    return await this.http.get<TransactionDeliveryNoteDto[]>(this.baseUrl + 'api/deliverynotes/' + deliveryNoteId + '/transactions').toPromise();
  }

  getDeliveryNotePdf(deliveryNoteId: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'api/deliverynotes/download/' + deliveryNoteId, { responseType: 'blob' as 'json'});
  }

  getDeliveryNoteAsCSV(deliveryNoteId: number): Observable<any> {
    return this.http.get<any>(this.baseUrl + 'api/deliverynotes/download/csv/' + deliveryNoteId, { responseType: 'blob' as 'json' });
  }

  sendDeliveryNoteMail(deliveryNoteId: number, eMailOverwrite: string): Observable<any> {
    const url = `${this.baseUrl}api/deliverynotes/mail/${deliveryNoteId}?eMailOverwrite=${encodeURIComponent(eMailOverwrite)}`;
    
    return this.http.get<any>(url);
}



  sendEmail(formData: FormData): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + 'api/deliverynotes/SendEmail', formData);
  }

  updateDeliveryNoteName(deliveryNoteName: DeliveryNoteName, deliveryNoteId: number): Observable<DeliveryNoteName> {
    return this.http.patch<DeliveryNoteName>(this.baseUrl + 'api/deliverynotes/' + deliveryNoteId, deliveryNoteName);
  }

  deleteDeliveryNote(id: number): Observable<DeliveryNote> {
    return this.http.delete<DeliveryNote>(this.baseUrl + 'api/deliverynotes/' + id);
  }

  matches(deliveryNote: DeliveryNote, term: string, pipe: PipeTransform) {
    // return deliveryNote.{property}.toLowerCase().includes(term.toLowerCase())
  }
}
